module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "d-flex pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [(_vm.isQuoteEdit) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openCreateQuoteModal()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Create\n        ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat fa-xs"
  }), _vm._v(" Reload\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.downloadMasterlistRpt()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("download")]), _vm._v(" Export Excel\n        ")], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-0",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "200px",
      "float": "right"
    },
    attrs: {
      "items": _vm.defaultYears,
      "label": "Year",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getMasterLists()
      }
    },
    model: {
      value: (_vm.selectedFilter.year),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "year", $$v)
      },
      expression: "selectedFilter.year"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.masterListSummary) ? _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "172px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Total Revenue Recognised - " + _vm._s(_vm.selectedFilter.year === 'All' ? '2024' : _vm.selectedFilter.year))]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.masterListSummary.revRecon)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "172px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line pb-0"
  }, [_vm._v("Total Revenue for " + _vm._s(_vm.currentMonthYear) + " (Current Month)")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('h3', {
    staticClass: "pt-3 mb-1"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.masterListSummary.revReconForMonth)))])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": _vm.openRecognizedRevenueModal
    }
  }, [_vm._v("\n            More Details\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "172px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Unallocated Revenues")]), _vm._v(" "), _c('v-card-text', [(_vm.selectedFilter.year === 'All') ? _c('h3', [_vm._v("-")]) : _c('h3', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.masterListSummary.unRecon)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "172px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Active Deal")]), _vm._v(" "), _c('v-card-text', [(_vm.selectedFilter.year === 'All') ? _c('h3', [_vm._v("-")]) : _c('h3', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.masterListSummary.activeDealCt)))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3 mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2",
      "md": "2",
      "lg": "2"
    }
  }, [(_vm.selectedLists.length > 0 && _vm.isSuperAdmin) ? _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": _vm.openActiveYearDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")]), _vm._v(" Update Active Year\n      ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "md": "10",
      "lg": "10"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "autocomplete-filter",
    attrs: {
      "items": _vm.saleUsers,
      "item-value": "id",
      "item-text": "firstName",
      "label": "Sale Person",
      "clearable": "",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.searchFilter()
      }
    },
    model: {
      value: (_vm.selectedFilter.salePerson),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "salePerson", $$v)
      },
      expression: "selectedFilter.salePerson"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "autocomplete-filter",
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "firstName",
      "label": "AM",
      "clearable": "",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.searchFilter()
      }
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "autocomplete-filter",
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "firstName",
      "label": "CC",
      "clearable": "",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.searchFilter()
      }
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  }), _vm._v(" "), _c('v-menu', {
    ref: "quoteDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "autocomplete-filter",
          staticStyle: {
            "max-width": "250px"
          },
          attrs: {
            "label": "Quote Acceptance Date",
            "placeholder": "Quote Acceptance Date",
            "clearable": "",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          on: {
            "change": function($event) {
              return _vm.searchFilter()
            }
          },
          model: {
            value: (_vm.selectedFilter.acceptedMonth),
            callback: function($$v) {
              _vm.$set(_vm.selectedFilter, "acceptedMonth", $$v)
            },
            expression: "selectedFilter.acceptedMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.quoteDateCal),
      callback: function($$v) {
        _vm.quoteDateCal = $$v
      },
      expression: "quoteDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.selectedFilter.acceptedMonth),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "acceptedMonth", $$v)
      },
      expression: "selectedFilter.acceptedMonth"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.searchFilter
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-right"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "master-lists-table elevation-1",
    attrs: {
      "headers": _vm.computedHeaders,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "items-per-page": 15,
      "show-select": "",
      "single-select": false
    },
    on: {
      "current-items": _vm.getFiltered,
      "toggle-select-all": _vm.selectAllLists
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('div', {
            key: index,
            staticClass: "col-header-title"
          }, [_vm._v("\n          " + _vm._s(h.text) + "\n          "), (_vm.showLock(("" + (h.value) + (_vm.selectedFilter.year))) && _vm.isQuoteEdit) ? _c('v-btn', {
            attrs: {
              "x-small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.changeLock(("" + (h.value) + (_vm.selectedFilter.year)), 'lock')
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('span', _vm._g({}, on), [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary"
                  }
                }, [_vm._v("mdi-lock-open-variant")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Lock")])])], 1) : _vm._e(), _vm._v(" "), (_vm.showUnlock(("" + (h.value) + (_vm.selectedFilter.year))) && _vm.isQuoteEdit) ? _c('v-btn', {
            attrs: {
              "x-small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.changeLock(("" + (h.value) + (_vm.selectedFilter.year)), 'unlock')
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('span', _vm._g({}, on), [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary"
                  }
                }, [_vm._v("mdi-lock")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Unlock")])])], 1) : _vm._e()], 1)]
        }
      }
    }), {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "30px!important"
          }
        }, [(_vm.isQuoteEdit) ? _c('div', {
          staticClass: "w-100 pt-1",
          staticStyle: {
            "margin-right": "10px"
          }
        }, [(_vm.isPendingTimeline(item.quoteData)) ? _c('v-badge', {
          staticClass: "masterlist-badge",
          attrs: {
            "color": "success",
            "icon": "mdi-clock-outline",
            "x-small": "",
            "overlap": ""
          }
        }, [_c('v-btn', {
          staticClass: "btn-action",
          attrs: {
            "color": "warning",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openFinanceEditDialog(item)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "title": "Edit Quote",
            "small": ""
          }
        }, [_vm._v("edit")]), _vm._v(" Edit Quote\n              ")], 1)], 1) : _c('v-btn', {
          staticClass: "btn-action",
          attrs: {
            "color": "warning",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openFinanceEditDialog(item)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Edit Quote",
            "small": ""
          }
        }, [_vm._v("edit")]), _vm._v(" Edit Quote\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSalesEdit) ? _c('div', {
          staticClass: "w-100 pt-1 pb-2"
        }, [_c('v-btn', {
          staticClass: "btn-action",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "color": "green",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openSalesEditDialog(item)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "small": ""
          }
        }, [_vm._v("edit")]), _vm._v(" Update\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "w-100 pb-1"
        }, [_c('v-btn', {
          staticClass: "btn-action",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "color": "warning",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.refreshMasterList(item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat fa-xs"
        }), _vm._v("  Refresh\n            ")])], 1)])]
      }
    }, {
      key: "item.formattedAcceptanceDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.formattedAcceptanceDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(item.formattedAcceptanceDate)))]) : _vm._e()])]
      }
    }, {
      key: "item.salePersonName",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.salePersonName) ? _c('span', [_vm._v(_vm._s(item.salePersonName))]) : _vm._e()])]
      }
    }, {
      key: "item.billingContactName",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "custom-text-truncate"
              }, [_vm._v(_vm._s(item.billingContactDisplay.Name || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.billingContactDisplay.Name || '-'))])])], 1)]
      }
    }, {
      key: "item.quoteNo",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.quoteNo) ? _c('div', [_vm._v(_vm._s(item.quoteNo))]) : _vm._e(), _vm._v(" "), (item.linkedIOs) ? _c('span', [_vm._v(_vm._s(_vm.showLinkedIO(item.linkedIOs)))]) : _vm._e()])]
      }
    }, {
      key: "item.quoteAmt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.quoteAmt) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.quoteAmt)))]) : _vm._e()])]
      }
    }, {
      key: "item.invoiceSent",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.invoiceSent) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.invoiceSent)))]) : _vm._e()])]
      }
    }, {
      key: "item.invoiceCreated",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.invoiceCreated) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.invoiceCreated)))]) : _vm._e()])]
      }
    }, {
      key: "item.invoicePending",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.invoicePending) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.invoicePending)))]) : _vm._e()])]
      }
    }, {
      key: "item.verticals",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.vertical) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.displayVerticals(item.vertical)) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.campaigns",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "200px!important"
          }
        }, [(item.campaignDisplays) ? _c('div', _vm._l((item.campaignDisplays), function(campaign, index) {
          return _c('div', {
            key: index
          }, [_c('v-chip', {
            staticClass: "campaign-name-chip",
            attrs: {
              "color": "primary",
              "small": "",
              "text-color": "secondary"
            }
          }, [_vm._v("\n                " + _vm._s(campaign.name) + "\n              ")])], 1)
        }), 0) : _vm._e()])]
      }
    }, {
      key: "item.indicateCost",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.indicateCost) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.indicateCost)))]) : _vm._e()])]
      }
    }, {
      key: "item.AM",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.AM) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.displayUsers(item.AM)) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.CC",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.CC) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.displayUsers(item.CC)) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.startMonth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.formatMonth(item.startMonth)) + "\n        ")])]
      }
    }, {
      key: "item.endMonth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.formatMonth(item.endMonth)) + "\n        ")])]
      }
    }, {
      key: "item.totalMonth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "30px!important"
          }
        }, [_c('b', {
          staticClass: "custom-bold"
        }, [_vm._v(_vm._s(item.totalMonth))])])]
      }
    }, {
      key: "item.priorYear",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.priorYear) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.priorYear)))]) : _vm._e()])]
      }
    }, {
      key: "item.Jan",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Jan', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Jan) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Jan)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Jan')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Jan')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Feb",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Feb', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Feb) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Feb)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Feb')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Feb')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Mar",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Mar', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Mar) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Mar)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Mar')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Mar')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Apr",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Apr', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Apr) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Apr)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Apr')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Apr')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.May",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('May', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.May) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.May)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'May')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'May')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Jun",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Jun', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Jun) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Jun)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Jun')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Jun')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Jul",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Jul', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Jul) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Jul)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Jul')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Jul')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Aug",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Aug', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Aug) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Aug)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Aug')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Aug')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Sep",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Sep', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Sep) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Sep)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Sep')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Sep')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Oct",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Oct', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Oct) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Oct)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Oct')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Oct')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Nov",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Nov', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Nov) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Nov)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Nov')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Nov')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Dec",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Dec', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Dec) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Dec)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Dec')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Dec')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.nextYear",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.nextYear) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.nextYear)))]) : _vm._e()])]
      }
    }, {
      key: "item.revenueYetRecognise",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.revenueYetRecognise) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.revenueYetRecognise)))]) : _vm._e()])]
      }
    }, {
      key: "item.unrecognisedRevenues",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.unrecognisedRevenues) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.unrecognisedRevenues)))]) : _vm._e()])]
      }
    }, {
      key: "item.accruedRevenue",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.accruedRevenue) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.accruedRevenue)))]) : _vm._e()])]
      }
    }, {
      key: "item.deferredRevenue",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.deferredRevenue) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.deferredRevenue)))]) : _vm._e()])]
      }
    }], null, true),
    model: {
      value: (_vm.selectedLists),
      callback: function($$v) {
        _vm.selectedLists = $$v
      },
      expression: "selectedLists"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.computedHeaders), function(item, index) {
    return _c('th', {
      key: index,
      staticClass: "text-center"
    }, [(_vm.totalValues[item.value]) ? _c('v-chip', {
      staticClass: "summary-chip",
      attrs: {
        "small": "",
        "color": "primary",
        "text-color": "white"
      }
    }, [_c('v-icon', {
      staticClass: "mr-0",
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("mdi-currency-usd")]), _vm._v(" " + _vm._s(_vm._f("thousandSeprator")(_vm.totalValues[item.value])) + "\n            ")], 1) : _vm._e()], 1)
  })], 2)])], 2)], 1), _vm._v(" "), _c('create-quote-modal', {
    attrs: {
      "value": _vm.createQuoteDialog,
      "editData": _vm.editData,
      "saleUsers": _vm.saleUsers
    },
    on: {
      "created": _vm.reload
    },
    model: {
      value: (_vm.createQuoteDialog),
      callback: function($$v) {
        _vm.createQuoteDialog = $$v
      },
      expression: "createQuoteDialog"
    }
  }), _vm._v(" "), _c('sales-edit-modal', {
    attrs: {
      "value": _vm.salesEditDialog,
      "editData": _vm.editData
    },
    on: {
      "created": _vm.reload
    },
    model: {
      value: (_vm.salesEditDialog),
      callback: function($$v) {
        _vm.salesEditDialog = $$v
      },
      expression: "salesEditDialog"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Masterlist",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), (_vm.masterListSummary) ? _c('recognized-revenue-modal', {
    attrs: {
      "value": _vm.revRecognizedDialog,
      "monthYearValues": _vm.masterListSummary.revsForMonthYear,
      "selectedFilter": _vm.selectedFilter,
      "masterlists": _vm.masterLists,
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    model: {
      value: (_vm.revRecognizedDialog),
      callback: function($$v) {
        _vm.revRecognizedDialog = $$v
      },
      expression: "revRecognizedDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('active-year-modal', {
    attrs: {
      "value": _vm.activeYearDialog,
      "items": _vm.selectedLists
    },
    model: {
      value: (_vm.activeYearDialog),
      callback: function($$v) {
        _vm.activeYearDialog = $$v
      },
      expression: "activeYearDialog"
    }
  }), _vm._v(" "), _c('distribution-edit-modal', {
    attrs: {
      "value": _vm.distributionEditDialog,
      "editItem": _vm.editDistribution
    },
    on: {
      "updated": _vm.getMasterLists
    },
    model: {
      value: (_vm.distributionEditDialog),
      callback: function($$v) {
        _vm.distributionEditDialog = $$v
      },
      expression: "distributionEditDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-687afd8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/MasterLists/DataTable.vue
// module id = 2169
// module chunks = 0